import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';
import smoothscroll from 'smoothscroll-polyfill';
Vue.config.productionTip = true

smoothscroll.polyfill();
// new Vue({
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app')
new Vue(Vue.util.extend({ router, store }, App)).$mount('#app');
